/* eslint-disable @typescript-eslint/no-shadow */
import { View, Text as PDFText } from '@react-pdf/renderer'

import { Currency } from '../../../../../types/currency'
import { addCommaToPrice } from '../../config/functions'
import styles from './styles/index.styles'

interface PriceAndNameProps {
  BookerName: string
  Currency: Currency
  AfterTaxPrice: number
  RefundAmount?: number
}

const PriceAndName = ({
  BookerName,
  Currency,
  AfterTaxPrice,
  RefundAmount = 0
}: PriceAndNameProps) => {
  return (
    <View style={styles.mainDiv}>
      <View style={styles.content}>
        <View style={styles.subject1}>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}>Booker Name:</PDFText>
            <PDFText
              style={{
                ...styles.subjectValue,
                fontFamily: 'IRANSans'
              }}>
              {BookerName}
            </PDFText>
          </View>
        </View>
        <View style={styles.subject2}>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}>Full Price:</PDFText>
            <PDFText style={styles.subjectValue}>{` ${addCommaToPrice(
              AfterTaxPrice
            )} ${Currency}`}</PDFText>
          </View>
          {/* Only shown when money is going back to the guest. */}
          {RefundAmount > 0 && (
            <View style={[styles.rowDirection, styles.refundRow]}>
              <PDFText style={styles.subjectTitle}>Refund Amount:</PDFText>
              <PDFText style={styles.subjectValue}>{` ${addCommaToPrice(
                RefundAmount
              )} ${Currency}`}</PDFText>
            </View>
          )}
        </View>
      </View>
    </View>
  )
}
export default PriceAndName
